import useQuery from '@api/hooks/useQuery'
import { faRankingStar } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Paper, Skeleton, Stack, Typography, useTheme } from '@mui/material'
import { BarChart } from '@mui/x-charts-pro/BarChart'
import MarketBasketReportsApi, { MarketBasketReportsKeys } from '@services/marketBasketReports.api'

export default function AnalystCreatedCounts() {
	const { data, isLoading } = useQuery({
		queryKey: MarketBasketReportsKeys.countsPerAnalyst,
		queryFn: MarketBasketReportsApi.countsPerAnalyst,
	})

	const dataset = data
		? data.map((d) => ({
				shortName: d.analyst.shortName,
				displayName: d.analyst.displayName,
				count: d.count,
			}))
		: null

	return <AnalystCreatedCountsUI data={dataset || []} isLoading={isLoading} />
}

export function AnalystCreatedCountsUI({
	data,
	isLoading = false,
}: {
	data: { shortName: string; displayName: string; count: number }[]
	isLoading?: boolean
}) {
	const theme = useTheme()
	const xLabels = data ? data.map((d) => d.displayName) : []
	const shortLabels = data ? data.map((d) => d.shortName) : []
	const values = data ? data.map((d) => d.count) : []

	return (
		<Paper elevation={1} sx={{ width: '100%' }}>
			<Stack direction="row" spacing={1} p="1rem" alignItems="center">
				<FontAwesomeIcon icon={faRankingStar} size="lg" />
				<Typography variant="h6">Market Basket created per Analyst</Typography>
				<Typography variant="body2" color="text.secondary">
					per week
				</Typography>
			</Stack>
			{isLoading || !data ? (
				<Skeleton variant="rectangular" width="100%" height={300} />
			) : (
				<BarChart
					xAxis={[
						{
							data: xLabels, // displayName array
							scaleType: 'band',
							valueFormatter: (value, context) => {
								// Use shortName only for axis ticks; tooltip keeps displayName
								if (context.location === 'tick') {
									const i = xLabels.indexOf(String(value))
									return shortLabels[i] ?? String(value)
								}
								return String(value) // tooltip title = displayName
							},
						},
					]}
					series={[
						{
							data: values,
							label: 'Baskets',
							valueFormatter: (v: number | null) => `${v ?? 0}`,
							color: theme.palette.primary.main,
						},
					]}
					hideLegend
					height={300}
					borderRadius={8}
				/>
			)}
		</Paper>
	)
}
